import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function PresidentAddressMetaData(
  section: string,
): PageMetaDataValues {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "Parlimen Ke-15",
    startDate: "2025-09-05",
    endDate: "2025-09-20",
    eventStatus: "https://schema.org/EventScheduled",
    eventAttendanceMode: "https://schema.org/MixedEventAttendanceMode",
    location: {
      "@type": "Place",
      name: "Singapore",
      address: {
        "@type": "PostalAddress",
        streetAddress: "1000 Toa Payoh North",
        addressLocality: "Singapore",
        postalCode: "318994",
        addressCountry: "Singapore",
      },
    },
  };
  const metaTags: MetaTagsProps = {
    title: "8 September Sidang Parlimen Singapura Terkini | Berita Harian",
    description:
      "Dapatkan rangkuman langsung dan laporan terkini perbahasan Anggota Parlimen (MP) Singapura hari ini. Ikuti analisis mendalam hanya di Berita Harian.",
    slug: `/${section.replace(/^\/+/, "")}`,
    jsonLd,
  };

  const gaData: GADataProps = {
    level2: section,
    title: "Parlimen_Ke-15_Index",
    section: section,
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
